import Head from "next/head";
import Image from "next/image";
// import AnimatedCursor from "react-animated-cursor";
import Layout from "@/components/layout/layout";
import { useRouter } from "next/router";
import { useState, useEffect, Suspense } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "@/styles/globals.css";
import "@/styles/responsive_table.css";
import GlobalLoader from "@/components/GlobalLoader";
import { Provider } from "react-redux";
import { wrapper } from "@/store/store";
import Script from "next/script";
import { useCanonicalUrl } from "@/utils/cannonicalUrl";
function MyApp({ Component, pageProps }) {
  const router = useRouter();
  const canonicalUrl = useCanonicalUrl();
  const isHomePage = router.pathname === "/";
  const { store, props } = wrapper.useWrappedStore(pageProps);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 500,
      easing: "ease-in-out",
    });
    AOS.refresh();

    const handleStart = () => setLoading(true);

    const handleComplete = () => {

      setTimeout(() => {
        const loader = document.querySelector(".loader");
        if (loader) {
          // loader.style.opacity = "0";

          // loader.style.visibility = "hidden";
          loader.remove();
        }
      }, 100);
      setLoading(false);
    };

    router.events.on("routeChangeStart", handleStart);
    router.events.on("routeChangeComplete", handleComplete);
    router.events.on("routeChangeError", handleComplete);

    return () => {
      router.events.off("routeChangeStart", handleStart);
      router.events.off("routeChangeComplete", handleComplete);
      router.events.off("routeChangeError", handleComplete);
    };
  }, [router]);

  return (
    <>
      {/* <base href="https://simpolo.com/"></base> */}
      <Head>
        <link rel="canonical" href={canonicalUrl} />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
        {/* <link
          rel="preload"
          href="/fonts/Corbert-Regular.ttf"
          as="font"
          type="font/ttf"
          crossorigin="anonymous"
        />
        <link
          rel="preload"
          href="/fonts/Corbert-Bold.ttf"
          as="font"
          type="font/ttf"
          crossorigin="anonymous"
        />
        <link
          rel="preload"
          href="/fonts/Corbert-Medium.ttf"
          as="font"
          type="font/ttf"
          crossorigin="anonymous"
        /> */}
        <link
          href="https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,100..900;1,9..144,100..900&display=swap"
          rel="stylesheet"
        />
      </Head>

      <Script
        src="https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
        strategy="afterInteractive"
      />

      <Script id="google-translate-init" strategy="afterInteractive">
        {`
          function googleTranslateElementInit() {
            new google.translate.TranslateElement({pageLanguage: 'en'}, 'google_translate_element');
          }
        `}
      </Script>

      <Provider store={store}>
        {Component.getLayout ? (
          Component.getLayout(<Component {...props} {...pageProps} />)
        ) : (
          <Layout>
            {/* {loading && <GlobalLoader />} */}
            <Suspense fallback={<GlobalLoader />}>
              <Component {...props} {...pageProps} />
            </Suspense>

          </Layout>
        )}
      </Provider>
    </>
  );
}

export default wrapper.withRedux(MyApp);
// export default MyApp;
